define( function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rcheckableType.js
// module id = 1815
// module chunks = 36